import { gql } from '@apollo/client/core';

// eslint-disable-next-line import/prefer-default-export
export const FETCH_PARENT_JOBS = gql`
  query fetchParentJobs($expiresAfter: DateTime) {
    viewer(kind: PARENT) {
      ... on Parent {
        jobs(jobStatuses: [OPEN], expiresAfter: $expiresAfter) {
          edges {
            node {
              id
              title
              careType
            }
          }
        }
      }
    }
  }
`;

// Sitter details for the interview request flow
export const SITTER_FOR_INTERVIEW_QUERY = gql`
  query sitterForInterview($accountId: UUID!) {
    account(id: $accountId) {
      ... on Sitter {
        id
        displayName
        photoUrl
        reviews {
          totalReviewCount
          starAggregate
        }
        profiles {
          babysitter {
            profile {
              payRate {
                min
                max
              }
            }
          }
        }
      }
    }
  }
`;
